/* ==========================================================================
   Homellence – S5 (Runde 47) · Der Abspielknopf am Video

   Das Skript macht genau zwei Dinge:

   1. Es nimmt dem gestalteten Abspielknopf das `hidden`. Vorher ist er
      nicht da - deshalb sieht jemand ohne JavaScript die Bedienelemente des
      Browsers und kann das Video ganz normal starten. Der Knopf erscheint
      also nur dort, wo er auch funktioniert.

   2. Beim Tippen startet es das Video und nimmt den Knopf weg.

   **Geladen wird vorher nichts.** Das steht nicht hier, sondern am Element:
   `preload="none"`. Das Skript aendert daran nichts und kann es auch nicht
   aushebeln - es ruft nur `play()`, und erst dann holt der Browser die
   Datei. Ein Video, das von selbst laedt, gibt es auf dieser Seite nicht.

   Faellt das Skript aus, faellt nur der Knopf aus. Das Video bleibt
   bedienbar, und es laedt weiterhin nichts von allein.
   ========================================================================== */
(function () {
  'use strict';

  function start(rahmen) {
    var video = rahmen.querySelector('[data-hl-video-player]');
    var knopf = rahmen.querySelector('[data-hl-video-play]');
    if (!video || !knopf) return;

    knopf.hidden = false;
    rahmen.classList.add('hl-video__frame--ready');

    function wegblenden() {
      knopf.hidden = true;
      rahmen.classList.add('hl-video__frame--playing');
    }

    knopf.addEventListener('click', function () {
      wegblenden();
      /* `play()` gibt ein Promise zurueck, das abgelehnt werden kann - etwa
         wenn der Browser den Start doch nicht zulaesst. Dann kommt der Knopf
         zurueck, statt dass jemand vor einem stehenden Bild sitzt. */
      var lauf = video.play();
      if (lauf && typeof lauf.catch === 'function') {
        lauf.catch(function () {
          knopf.hidden = false;
          rahmen.classList.remove('hl-video__frame--playing');
        });
      }
    });

    /* Wer die Bedienelemente des Browsers benutzt, soll den Knopf ebenfalls
       los sein. */
    video.addEventListener('play', wegblenden);
  }

  function bereit() {
    var rahmen = document.querySelectorAll('[data-hl-video]');
    for (var i = 0; i < rahmen.length; i++) start(rahmen[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bereit);
  } else {
    bereit();
  }

  /* Im Theme-Editor wird eine Section neu aufgebaut. Dann noch einmal. */
  document.addEventListener('shopify:section:load', function (event) {
    var rahmen = event.target.querySelectorAll('[data-hl-video]');
    for (var i = 0; i < rahmen.length; i++) start(rahmen[i]);
  });
})();
